module.exports = __webpack_public_path__ + "static/media/mottu.61bdca9b.webp";